import { useEffect } from "react";
import { useSyncStore } from "@/state/sync";

export function SyncManager() {
  const flush = useSyncStore((state) => state.flush);
  const refresh = useSyncStore((state) => state.refresh);
  useEffect(() => {
    void refresh().then(flush);
    const sync = () => void flush();
    const offline = () => void refresh();
    window.addEventListener("online", sync);
    window.addEventListener("offline", offline);
    window.addEventListener("focus", sync);
    const timer = window.setInterval(sync, 30_000);
    return () => {
      window.removeEventListener("online", sync);
      window.removeEventListener("offline", offline);
      window.removeEventListener("focus", sync);
      window.clearInterval(timer);
    };
  }, [flush, refresh]);
  return null;
}
